// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__ksfb1","spin":"loader_spin__4wJqm"};